<template>
    <div>

        <v-form v-model="valid" ref="formData">

            <v-dialog v-model="dialogPayment" persistent width="50%">
                <v-overlay :value="overlay">
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>
                </v-overlay>

                <v-card>
                    <v-card-title>
                        <span>{{ $t("payment") }}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            text
                            icon
                            @click="handleClose"
                            valid="false"
                            v-shortkey="['esc']"
                            @shortkey.native="handleClose"
                        >
                            <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6" md="6" class="seperate-line-verticle">

                                <v-row style="padding-right: 10px">

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            v-model="formPayment.supplier_name"
                                            outlined
                                            :dense="dense"
                                            :label="$t('supplier') + '*'"
                                            disabled
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            v-model="formPayment.client_name"
                                            outlined
                                            :dense="dense"
                                            :label="$t('client') + '*'"
                                            disabled
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-select
                                            v-model="formPayment.currency_code"
                                            :items="currencyOptionList"
                                            disabled
                                            :label="$t('currency')"
                                            outlined
                                            item-text="text"
                                            item-value="id"
                                            dense
                                        ></v-select>
                                    </v-col>

                                     <!-- <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px; padding-top: 5px">
                                        <v-select
                                            :items="paymentMethod"
                                            :label="$t('paymentMethod')"
                                            outlined
                                            v-model="formPayment.payment_method"
                                            dense
                                            disabled
                                        >
                                            <template v-slot:selection="{ item }">{{ $t(item) }}</template>
                                            <template v-slot:item="{ item }">{{ $t(item) }}</template>
                                        </v-select>
                                    </v-col> -->

                                    <v-col cols="12" sm="12" md="12" v-if="formPayment.payment_method == 'cash'">
                                        <v-select
                                            :items="customerWallet"
                                            :label="$t('wallet') + '*'"
                                            outlined
                                            v-model="formPayment.wallet_account"
                                            :rules="selectRules"
                                            item-text="account_type_name"
                                            item-value="account_type_name"
                                            dense
                                        >
                                            <template v-slot:selection="{item}">
                                                {{$t(item.account_type_name) }} : {{ item.available_balance |
                                                formatNumber}} {{currency_symbol}}
                                            </template>
                                            <template v-slot:item="{item}">
                                                {{ $t(item.account_type_name) }} : {{ item.available_balance |
                                                formatNumber}} {{currency_symbol}}
                                            </template>
                                        </v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-menu
                                            v-model="menuDate"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="formPayment.date"
                                                    :label="$t('receivePaymentDate') + '*'"
                                                    prepend-inner-icon="mdi-calendar"
                                                    outlined
                                                    dense
                                                    readonly
                                                    :rules="dateRules"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                :first-day-of-week="0"
                                                v-model="formPayment.date"
                                                :rules="dateRules"
                                                @input="menuDate = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            v-model="formPayment.reference"
                                            outlined
                                            dense
                                            :label="$t('reference')"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-row>
                                    <!-- <v-col cols="5" sm="5">{{ $t("step") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ formPayment.step}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("duration") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ formPayment.duration }} {{ $t(formPayment.duration_type.split("_")[1])}}</span></v-col> -->

                                    <v-col cols="5" sm="5">{{ $t("totalAmount") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ +formPayment.total_amount | formatNumber}} {{getCurrencySymbol(formPayment.currency_code)}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("paid") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ +formPayment.complete_paid | formatNumber }} {{getCurrencySymbol(formPayment.currency_code)}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("partial") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ +formPayment.total_payment | formatNumber }} {{getCurrencySymbol(formPayment.currency_code)}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("percentage") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ calculatePercentage }}%</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("paidAmount") }}</v-col>
                                    <v-col cols="7" sm="7">
                                        <v-text-field
                                            v-model="formPayment.paid_amount"
                                            outlined
                                            dense
                                            :max="formPayment.total_payment"
                                            min="1"
                                            style="margin-bottom: -10px"
                                            required
                                            :rules="requireAndNumberAtleaseOne"
                                            >
                                        </v-text-field>
                                        <span v-show="! this.valid_paid" class="error--text">{{ $t('maximum') + ' ' + formPayment.total_payment }} </span>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea
                                            clearable
                                            outlined
                                            :placeholder="$t('yourDesc')"
                                            v-model="formPayment.note"
                                            clear-icon="mdi-close-circle"
                                            rows="3"
                                            auto-grow
                                            :label="$t('note')"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            rounded
                            @click="submitPayment($event,true)"
                            style="min-width: 150px"
                            color="primary"
                            :disabled="! this.valid_paid"
                        >
                            <font-awesome-icon
                                icon="check-circle"
                                style="margin-right: 10px"
                            />
                            {{$t("payAndPrint")}}
                        </v-btn>
                        <v-btn
                            rounded
                            @click="submitPayment($event)"
                            style="min-width: 150px"
                            color="success"
                            :disabled="! this.valid_paid"
                        >
                            <font-awesome-icon
                                icon="check-circle"
                                style="margin-right: 10px"
                            />
                            {{$t("proceedPay")}}

                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog>

        </v-form>

    </div>
</template>
<script>

    import OptionDataMixin from "../../../mixins/optionDataMixin";
    import MainMixin from "../../../mixins/mainMixin";
    import ValidatorMixin from "../../../mixins/validatorMixin";
    import {provider} from "@/service/provider";
    import axios from "axios";
    import moment from "moment";


    export default {
        name: "farmerPayment",
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        data() {
            return {
                currency_symbol: "",
                valid_paid: true,

                formPayment: {
                    id: '',
                    reference: "",
                    client_id: "",
                    supplier_id: "",
                    supplier_name: "",
                    currency_code: "",
                    note: '',
                    date: moment().format("YYYY-MM-DD"),
                    total_payment: "",
                    complete_paid: "",
                    total_amount: "",
                    paid_amount: "",
                    payment_type: '',
                    client_name: "",
                    client_phone: "",
                    client_card_type: 'id_card',
                    client_card_number: '',
                    client_photo: [],
                    client_account_no: '',
                    supplier_account_no:'',
                    wallet_account: "",
                    transaction_id: "",
                    transaction_payment_term_id: "",
                    step: "1",
                    percentage: "100",
                    duration: "0",
                    duration_type: '',
                    payment_method: 'cash'
                },

            };
        },

        methods: {
            
            reset() {
                if(this.$refs.formData){
                    this.$refs.formData.reset();
                    this.formPayment.date = '';
                    this.formPayment.paid_amount = 0;
                    this.formPayment.total_payment= 0;
                    this.formPayment.complete_paid = 0;
                    this.formPayment.total_amount= 0;
                }
            },

            handleClose(){
                this.$store.dispatch('updateFarmerDialogPayment', {dialog: false, transaction_id: '', client_id: ''});
            },

            submitPayment(event, isPrint) {
                let vm = this;
                event.preventDefault();
                if (vm.$refs.formData.validate()) {
                   
                    vm.overlay = true;
                    let url = provider.baseURL + provider.storePaymentTerm;
                    return new Promise((resolve, reject) => {
                        axios.post(url, this.formPayment, {headers: {Authorization: localStorage.token}}).then(
                            res => {
                                if (res.data.response && res.data.response.code === 200) {
                                    resolve(res.data.data.payment_transaction_id);
                                    vm.$notify({
                                        title: "Success",
                                        message: vm.$t("success"),
                                        type: "success",
                                        duration: 700
                                    });
                                    vm.dialog = false;
                                    if (isPrint === true) {

                                        if(vm.isShop || vm.isAgent || vm.isExpess || vm.isFarmer)
                                        {
                                            vm.$router.push({name: 'beeshop.agri-input.order-farmer-management.print-invoice-farmer', params: { id: res.data.data.invoice_transaction_id, back: 'beeshop.agri-input.order-farmer-management.farmer-payment-board'}})
                                        }
                                        else {
                                            vm.$router.push({name: 'beeshop.agri-input.order-farmer-management.print-invoice-farmer', params: { id: res.data.data.invoice_transaction_id, type:"sale_order", back: 'beeshop.agri-input.order-farmer-management.farmer-payment-board'}})
                                        }
                                    }
                                    vm.overlay = false;
                                    vm.$store.dispatch('updateFarmerDialogPayment', {dialog: false, transaction_id: '', client_id: ''});
                                }
                                else{
                                    vm.$notify({
                                        title: "Error",
                                        message: res.data.response.message,
                                        type: "error",
                                        duration: 2000
                                    });
                                    vm.overlay = false;
                                }
                            },
                            error => {
                                reject(error);
                                vm.overlay = false;

                            }

                        );
                    });

                }
            },

        },

        watch: {
            dialogPayment(val) {
                if (val === false) { this.reset(); }
                else {
                    // this.fetchClientOption(localStorage.contact_id);
                    // this.fetchSupplierOption();
                    this.fetchCurrencyOption();
                }
            },

            async transaction_id(transaction_id){
                if(transaction_id){
                    /** Fetch the payment terms */
                    let vm = this;
                    this.formPayment.date = moment().format("YYYY-MM-DD");
                    this.overlay = true;

                    let params = {
                        search: '',
                        transaction_id: transaction_id,
                        contact_id: this.$store.state.farmer.client_id,
                        type_order: 'purchase_order',
                        due_date: '',
                        offset: 0,
                        sort_by: "created_at",
                        sort_desc: 1,
                        limit: 1
                    }

                    let url = provider.baseURL + provider.getDueTransactionPaymentTerm;

                    await axios.post(url, params, {headers: {Authorization: localStorage.token}}).then(res => {
                        if (res.data.response && res.data.response.code === 200) {
                            let data = res.data.data[0];
                            vm.formPayment.client_id           = data.client_id;
                            vm.formPayment.supplier_id         = data.supplier_id;
                            vm.formPayment.supplier_name       = data.supplier;
                            vm.formPayment.client_account_no   = data.client_account_no;
                            vm.formPayment.supplier_account_no = data.supplier_account_no;
                            vm.formPayment.currency_code       = data.currency_code;
                            vm.formPayment.total_payment       = data.total_payment;
                            vm.formPayment.paid_amount         = data.total_payment;
                            vm.formPayment.total_amount        = data.total_amount;
                            vm.formPayment.complete_paid       = data.complete_paid;
                            vm.formPayment.payment_type        = data.payment_method;
                            vm.formPayment.client_name         = data.client;
                            vm.formPayment.client_phone        = data.client_phone;
                            vm.formPayment.transaction_id      = data.transaction_id;
                            vm.formPayment.transaction_payment_term_id = data.transaction_payment_term_id;
                            vm.formPayment.duration_type       = data.duration_type;
                            // vm.formPayment.payment_method      = data.payment_method;
                            vm.overlay = false;

                            if(data.client_type == 'farmer' && data.payment_method == 'cash' && data.client_id == '10001100110000001'){ //10001100110000001 អតិថិជនមកទិញផ្ទាល់់
                                this.formPayment.client_account_no = this.formPayment.supplier_account_no;
                            }else if(data.client_type == 'farmer' && data.payment_method == 'cash'){
                                this.formPayment.client_account_no = data.client_account_no;
                            }
                        }   
                    }).catch(error => {
                        vm.overlay = false;
                        console.log(error)
                    });

                    /** Fethc the waller account */
                    this.customerWallet = [];
                    await this.fetchWalletByCustomer(this.formPayment.client_account_no, this.formPayment.currency_code);
                }
            },

            "formPayment.paid_amount"(val){
                let paid_amount  = +val;
                let total_amount = this.formPayment.total_payment;
                if(paid_amount > total_amount){
                    this.valid_paid = false;
                }
                else{
                    this.valid_paid = true;
                }
            }
        },
        computed: {
            calculatePercentage(){
                let per = (+this.formPayment.total_amount - +this.formPayment.complete_paid) / (+this.formPayment.total_amount / 100);
                if(! per){ per = 0; }
                return per.toFixed(2);
            },
            dialogPayment(){
                return this.$store.state.farmer.dialog;
            },  

            transaction_id(){
                return this.$store.state.farmer.transaction_id;
            }
        },
    };
</script>
